var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "resend-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M0,0H16V16H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M4.309,3.622a6.667,6.667,0,0,1,9.818,8.871L12,8.667h2A5.333,5.333,0,0,0,4.973,4.819l-.665-1.2Zm8.716,10.089A6.667,6.667,0,0,1,3.207,4.84L5.333,8.667h-2a5.333,5.333,0,0,0,9.027,3.848Z",
    transform: "translate(-0.667 -0.667)",
    fill: "#7aba56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendIcon);
export default __webpack_public_path__ + "static/media/resend-icon.cc3abc321eb440f76dec0e1c7072876e.svg";
export { ForwardRef as ReactComponent };